
import MSArea from './msarea';
import CartesianStackGroup from '../_internal/datasets/groups/cartesian.stack';
import { HUNDREDSTRING } from '../_internal/lib/lib';

class StackedArea2D extends MSArea {
  /**
   * Provides the name of the chart extension
   *
   * @static
   * @return {string} The name of the chart extension
   */
  static getName () {
    return 'StackedArea2D';
  }

  constructor () {
    super();
    this.showsum = 0;
  }
  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'StackedArea2D';
  }
  __setDefaultConfig () {
    super.__setDefaultConfig();
    let config = this.config;
    config.friendlyName = 'Stacked Area Chart';
    config.plotfillalpha = HUNDREDSTRING;
    config.isstacked = 1;
  }

  /** This method return the dataset-group definations for this charts **/
  getDSGroupdef () {
    return CartesianStackGroup;
  }
}
export default StackedArea2D;
